<script>
import { mapActions } from "vuex";
import { DealerManager } from "../../models/dealerPortal/DealerManager";

export default {
  name: "partnerDetail",
  data() {
    return {
      editedItem: new DealerManager(),
      editedIndex: 0,
      valid: true,
      SearchText: null,
      loading: false,
      dealerTypes: [],
      dealerLevels: [
        { value: 1, text: "Dealer" },
        { value: 2, text: "Dealer Manager" }
      ]
    };
  },
  methods: {
    ...mapActions("partner", [
      "getPartnerData",
      "getDealerTypes",
      "editPartner"
    ]),
    save() {
      let vm = this;
      vm.editPartner(this.editedItem);
      this.$emit("save");
    },
    undo() {
      this.$emit("closeEdit");
    },
    loadData(dealerID) {
      this.getDealerTypes().then(data => {
        this.dealerTypes = data;
      });
      if (dealerID > 0)
        this.getPartnerData({ url: `commissions/GetPartner/${dealerID}` })
          .then(data => {
            if (data.length) this.editedItem = data[0];
          })
          .catch(() => {});
    }
  },
  computed: {}
};
</script>
<template>
  <v-card>
    <v-card-text>
      <v-col sm="12">
        <v-card>
          <app-title>Partner Relationship</app-title>
          <v-row class="ma-1"   >
            <v-col>
              <v-text-field v-model="editedItem.dealerId" label="dealerID" required readonly></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="editedItem.dealerManagerId"
                label="Dealer Manager"
                :error-messages="errors.collect('dealerManager')"
                v-validate="'required'"
                data-vv-name="dealerManager"
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                name="DealerLevel"
                label="Dealer Level"
                v-validate="'required'"
                :error-messages="errors.collect('DealerLevel')"
                v-model="editedItem.levelID"
                :items="dealerLevels"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                name="DealerType"
                label="Dealer Type"
                v-validate="'required'"
                :error-messages="errors.collect('DealerType')"
                v-model="editedItem.dealerTypeID"
                :items="dealerTypes"
                item-text="dealerType"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col>
              <v-checkbox
                name="produceRCTI"
                label="Produce RCTI"
                v-validate="'required'"
                :error-messages="errors.collect('productRCTI')"
                v-model="editedItem.produceRcti"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <app-title>Company Registration</app-title>
        <v-card>
          <v-row   class="ma-1">
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.registeredCompanyName"
                label="Registered Company Name"
                :error-messages="errors.collect('registeredCompanyName')"
                v-validate="'required'"
                data-vv-name="registeredCompanyName"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.tradingName"
                label="Trading Name"
                :error-messages="errors.collect('tradingName')"
                v-validate="'required'"
                data-vv-name="tradingName"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.abn"
                label="ABN"
                :error-messages="errors.collect('abn')"
                v-validate="'required'"
                data-vv-name="abn"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <app-title>Address</app-title>
        <v-card>
          <v-row   class="ma-1">
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.address"
                label="Address"
                :error-messages="errors.collect('address')"
                v-validate="'required'"
                data-vv-name="address"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.city"
                label="City"
                :error-messages="errors.collect('city')"
                v-validate="'required'"
                data-vv-name="city"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="editedItem.state"
                label="State"
                :error-messages="errors.collect('state')"
                v-validate="'required'"
                data-vv-name="state"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model="editedItem.postcode"
                label="PostCode"
                :error-messages="errors.collect('postcode')"
                v-validate="'required'"
                data-vv-name="postcode"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <app-title>Director Details</app-title>
        <v-card>
          <v-row   class="ma-1">
            <v-col cols="3">
              <v-text-field
                type="number"
                v-model="editedItem.yrsEstablished"
                label="Years Established"
                :error-messages="errors.collect('yrsEstablished')"
                v-validate="'required|numeric'"
                data-vv-name="yrsEstablished"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.directorsName"
                label="Director's Name"
                :error-messages="errors.collect('directorsName')"
                v-validate="'required'"
                data-vv-name="directorsName"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.driversLicense"
                label="Drivers Licence Number"
                :error-messages="errors.collect('driversLicense')"
                v-validate="'required'"
                data-vv-name="driversLicense"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.telephoneNo"
                label="Telephone"
                :error-messages="errors.collect('telephoneNo')"
                v-validate="'required|phonenumber'"
                data-vv-name="telephoneNo"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="editedItem.mobileNo"
                label="Mobile"
                :error-messages="errors.collect('mobileNo')"
                v-validate="'required|mobilenumber'"
                data-vv-name="mobileNo"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.email"
                label="Email"
                :error-messages="errors.collect('email')"
                v-validate="'required|email'"
                data-vv-name="email"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                name="numberSubAgents"
                label="Number of Sub Agents"
                v-model="editedItem.numberSubAgents"
                :error-messages="errors.collect('numberSubAgents')"
                v-validate="'required'"
              ></v-text-field>
            </v-col>
            <v-col cols="12"></v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.firstName"
                label="Contact First Name"
                :error-messages="errors.collect('firstName')"
                v-validate="'required'"
                data-vv-name="firstName"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.lastName"
                label="Contact Last Name"
                :error-messages="errors.collect('lastName')"
                v-validate="'required'"
                data-vv-name="lastName"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <app-title>Banking Details</app-title>
        <v-card>
          <v-row   class="ma-1">
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.bank"
                label="Bank"
                :error-messages="errors.collect('bank')"
                v-validate="'required'"
                data-vv-name="bank"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.accountName"
                label="Account Name"
                :error-messages="errors.collect('accountName')"
                v-validate="'required'"
                data-vv-name="accountName"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.accountNo"
                label="Account No"
                :error-messages="errors.collect('accountNo')"
                v-validate="'required'"
                data-vv-name="accountNo"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedItem.bsbno"
                label="BSB"
                :error-messages="errors.collect('bsbno')"
                v-validate="'required'"
                data-vv-name="bsbno"
                mask="###-###"
                required
                return-masked-value
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.branchAddress"
                label="Branch Address"
                :error-messages="errors.collect('branchAddress')"
                v-validate="'required'"
                data-vv-name="branchAddress"
                required
              ></v-text-field>
            </v-col>

            <v-col class="text-right" >
              <v-btn @click="save" color="primary">Save</v-btn>
              <v-btn @click="undo" color="light-grey">Cancel</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-card-text>
  </v-card>
</template>

